import React from 'react';
import { useI18next, useTranslation } from 'gatsby-plugin-react-i18next';
import ItemParent from './ItemParent';
import ItemMenu from './ItemMenu';
import { getMenuItems } from './menu-items';

import * as S from './NavMenu.styled';

const NavMenu = () => {
  const { language } = useI18next();
  const { t } = useTranslation(['seoNav']);

  const menuItems = getMenuItems(language);

  const RendererMenu = () =>
    menuItems.map((entry) => {
      const hasSubMenu = !!entry.items;
      return (
        <ItemParent
          id={entry.label}
          key={entry.label}
          label={t(entry.label)}
          href={entry.href}
          hasSubMenu={hasSubMenu}
        >
          {hasSubMenu && (
            <S.UnorderedList>
              {entry.items.map((subMenuItems, index) => (
                // eslint-disable-next-line react/no-array-index-key
                <div key={`${entry.label}-${index}`}>
                  {subMenuItems.map((subMenuItem, subMenuItemIndex) => {
                    const itemKey =
                      subMenuItemIndex === 0 && subMenuItem !== ''
                        ? t(subMenuItem)
                        : t(subMenuItem.label);

                    if (subMenuItemIndex === 0 && subMenuItem !== '') {
                      return (
                        <S.Category key={itemKey}>{t(subMenuItem)}</S.Category>
                      );
                    }
                    if (subMenuItemIndex > 0) {
                      return (
                        <ItemMenu
                          id={subMenuItem.label}
                          label={t(subMenuItem.label)}
                          href={subMenuItem.href}
                          key={itemKey}
                          isSubEntry={subMenuItem.subEntry}
                        />
                      );
                    }
                    return null;
                  })}
                </div>
              ))}
            </S.UnorderedList>
          )}
        </ItemParent>
      );
    });

  return (
    <S.NavWrapper>
      <S.UnorderedList>
        <RendererMenu />
      </S.UnorderedList>
    </S.NavWrapper>
  );
};

export default NavMenu;
